import asArray from 'utils/arrays/asArray.util';

export const addSearchedService = (options) => {
  const { service, addedServices, client = null, addService, location, history } = options;
  const addedServicesArray = asArray(addedServices);

  const newService = Object.assign({}, service);
  if (!newService.appointment) {
    newService.appointment = {};
  }
  let newClient;
  if (addedServicesArray.length > 0) {
    if (addedServicesArray[0].appointment.client !== 'walkIn') {
      newClient = { ...addedServicesArray[0].appointment.client, notes: '' };
    } else {
      newClient = null;
    }
  } else if (client && client !== 'walkIn') {
    newClient = { ...client, notes: '' };
  } else {
    newClient = 'walkIn';
  }
  newService.service_id = newService.id;
  delete newService.id;
  newService.color = service.color;
  newService.appointment.client = newClient;
  addService(newService);
  if (location.pathname.indexOf('edit') > 0) {
    history.goBack();
  }
};
